import { render, staticRenderFns } from "./edit-document.vue?vue&type=template&id=d20242d2"
import script from "./edit-document.vue?vue&type=script&lang=js"
export * from "./edit-document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports